var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ImportTaskEnv_1;
import '@symon-ai/wisepipe-common'; // force import for JsonSchema
import '@symon-ai/wisepipe-common-auth';
import '@symon-ai/wisepipe-common-connection'; // force import for JsonSchema
import { JSON, JsonSchema } from '@symon-ai/wisepipe-serialize';
import './dataSource'; // force import for JsonSchema
import './originModel'; // force import for JsonSchema
const ImportTaskEnvSchema = {
    $id: 'urn:wisepipe-common-data:ImportTaskEnv',
    type: 'object',
    properties: {
        stage: { type: 'string', minLength: 1 },
        apiUrl: { type: 'string', format: 'uri' },
        s3DataBucket: { type: 'string', minLength: 1 },
        googleClientIDParam: { type: 'string', minLength: 1 },
        googleClientSecretParam: { type: 'string', minLength: 1 },
        googleSheetsImportClientIDParam: { type: 'string', minLength: 1 },
        googleSheetsImportClientSecretParam: { type: 'string', minLength: 1 },
        googleAdWordsDevTokenParam: { type: 'string', minLength: 1 },
        salesforceClientIDParam: { type: 'string', minLength: 1 },
        salesforceClientSecretParam: { type: 'string', minLength: 1 },
        hubspotClientIDParam: { type: 'string', minLength: 1 },
        hubspotClientSecretParam: { type: 'string', minLength: 1 },
        dynamicsClientIDParam: { type: 'string', minLength: 1 },
        dynamicsClientSecretParam: { type: 'string', minLength: 1 },
        onedriveClientIDParam: { type: 'string', minLength: 1 },
        onedriveClientSecretParam: { type: 'string', minLength: 1 },
        originModel: { $ref: 'urn:wisepipe-common-data:OriginModel' },
        connection: { $ref: 'urn:wisepipe-common-connection:Connection' },
        credentials: { $ref: 'urn:wisepipe-common:Credentials' },
        awsS3credentials: { $ref: 'urn:wisepipe-common-auth:AwsCredentials' },
        tempS3UploadFolder: { $ref: 'urn:wisepipe-common:S3File' },
        taskAuthInfo: { $ref: 'urn:wisepipe-common-auth:TaskAuthInfo' },
        transient: { type: 'boolean' },
        encryptionSecretName: { type: 'string', minLength: 1 },
        oldDataSources: { type: 'array', items: { $ref: 'urn:wisepipe-common-data:DataSource' } }
    },
    required: [
        'stage',
        'apiUrl',
        's3DataBucket',
        'originModel',
        'googleClientIDParam',
        'googleClientSecretParam',
        'googleSheetsImportClientIDParam',
        'googleSheetsImportClientSecretParam',
        'googleAdWordsDevTokenParam',
        'salesforceClientIDParam',
        'salesforceClientSecretParam',
        'hubspotClientIDParam',
        'hubspotClientSecretParam',
        'dynamicsClientIDParam',
        'dynamicsClientSecretParam',
        'transient'
    ]
};
let ImportTaskEnv = ImportTaskEnv_1 = class ImportTaskEnv {
    constructor(stage, apiUrl, s3DataBucket, originModel, googleClientIDParam, googleClientSecretParam, googleSheetsImportClientIDParam, googleSheetsImportClientSecretParam, googleAdWordsDevTokenParam, salesforceClientIDParam, salesforceClientSecretParam, hubspotClientIDParam, hubspotClientSecretParam, dynamicsClientIDParam, dynamicsClientSecretParam, onedriveClientIDParam, onedriveClientSecretParam, connection, credentials, awsS3credentials, tempS3UploadFolder, transient = false, encryptionSecretName, oldDataSources, taskAuthInfo) {
        this.hubspotClientIDParam = hubspotClientIDParam;
        this.hubspotClientSecretParam = hubspotClientSecretParam;
        this.dynamicsClientIDParam = dynamicsClientIDParam;
        this.dynamicsClientSecretParam = dynamicsClientSecretParam;
        this.onedriveClientIDParam = onedriveClientIDParam;
        this.onedriveClientSecretParam = onedriveClientSecretParam;
        this.stage = stage;
        this.apiUrl = apiUrl;
        this.s3DataBucket = s3DataBucket;
        this.originModel = originModel;
        this.googleClientIDParam = googleClientIDParam;
        this.googleClientSecretParam = googleClientSecretParam;
        this.googleSheetsImportClientIDParam = googleSheetsImportClientIDParam;
        this.googleSheetsImportClientSecretParam = googleSheetsImportClientSecretParam;
        this.googleAdWordsDevTokenParam = googleAdWordsDevTokenParam;
        this.salesforceClientIDParam = salesforceClientIDParam;
        this.salesforceClientSecretParam = salesforceClientSecretParam;
        this.connection = connection;
        this.credentials = credentials;
        this.awsS3credentials = awsS3credentials;
        this.tempS3UploadFolder = tempS3UploadFolder;
        this.transient = transient;
        this.encryptionSecretName = encryptionSecretName;
        this.oldDataSources = oldDataSources;
        this.taskAuthInfo = taskAuthInfo;
        JSON.validate(this, ImportTaskEnv_1);
    }
};
ImportTaskEnv = ImportTaskEnv_1 = __decorate([
    JsonSchema(ImportTaskEnvSchema)
], ImportTaskEnv);
export { ImportTaskEnv };
//# sourceMappingURL=importTaskEnv.js.map